// faviconBadge — overlays an unread dot on the app favicon. setFaviconBadge(n)
// draws the original favicon onto a canvas with a small red dot when n > 0, and
// restores the untouched favicon at 0. Signals unread notifications while the
// tab is backgrounded (the dot is visible in the browser tab strip).

let linkEl: HTMLLinkElement | null = null;
let originalHref: string | null = null;
let baseImg: HTMLImageElement | null = null;
let baseLoaded = false;
let lastCount = -1;

function ensureLink(): HTMLLinkElement {
  if (linkEl) return linkEl;
  let el = document.querySelector<HTMLLinkElement>('link[rel~="icon"]');
  if (!el) {
    el = document.createElement('link');
    el.rel = 'icon';
    document.head.appendChild(el);
  }
  linkEl = el;
  // Capture the pristine favicon URL before we ever overwrite it with a data URL.
  originalHref = el.href || '/favicon.ico';
  return el;
}

function loadBase(href: string): void {
  const img = new Image();
  img.onload = () => {
    baseImg = img;
    baseLoaded = true;
    if (lastCount > 0) draw();
  };
  img.onerror = () => {
    baseLoaded = true;
  }; // fall back to a dot-only badge
  img.src = href;
}

function draw(): void {
  const el = ensureLink();
  const size = 64;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const g = canvas.getContext('2d');
  if (!g) return;
  if (baseImg && baseLoaded) g.drawImage(baseImg, 0, 0, size, size);
  const r = size * 0.28;
  const cx = size - r - 2;
  const cy = r + 2;
  g.beginPath();
  g.arc(cx, cy, r, 0, Math.PI * 2);
  g.fillStyle = '#ef4444';
  g.fill();
  g.lineWidth = size * 0.06;
  g.strokeStyle = '#ffffff';
  g.stroke();
  el.href = canvas.toDataURL('image/png');
}

/** Show (count > 0) or clear (count <= 0) the unread dot on the favicon. */
export function setFaviconBadge(count: number): void {
  if (count === lastCount) return;
  lastCount = count;
  const el = ensureLink();
  if (originalHref && !baseImg && !baseLoaded) loadBase(originalHref);
  if (count <= 0) {
    if (originalHref) el.href = originalHref;
    return;
  }
  draw();
}
